import { render, staticRenderFns } from "./HomeCollectionsInputItem.vue?vue&type=template&id=58318e0c&scoped=true&"
import script from "./HomeCollectionsInputItem.vue?vue&type=script&lang=js&"
export * from "./HomeCollectionsInputItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58318e0c",
  null
  
)

export default component.exports